<template>
  <form class="article" @submit.prevent="validate(true)">
    <div class="field">
      <input class="field__input" name="name" v-model="formData.name" :class="{'field__input--error': errors.name, 'field__input--filled': formData.name }" />
      <div class="field__label" :class="{'filled': formData.name}">Ваше имя</div>
      <div class="field__error">{{ errors.name }}</div>
    </div>
    <div class="field">
      <input class="field__input" name="email" v-model="formData.email" :class="{'field__input--error': errors.email, 'field__input--filled': formData.email }" />
      <div class="field__label" :class="{'filled': formData.email}">Электронная почта</div>
      <div class="field__error">{{ errors.email }}</div>
    </div>
    <div class="field">
      <input class="field__input" name="phone" v-model="formData.phone" :class="{'field__input--filled': formData.phone }" />
      <div class="field__label" :class="{'filled': formData.phone}">Телефон</div>
    </div>
    <div class="field" v-if="mode == 'equipment'">
      <select class="field__input field__input--select" v-model="formData.equipment" placeholder="Тип оборудования">
        <option value="kiosk">Сенсорные киоски</option>
        <option value="street">Уличные киоски</option>
        <option value="terminal">Терминалы самообслуживания</option>
        <option value="table">Сенсорные столы</option>
        <option value="presentation">Презентационное оборудование</option>
        <option value="custom">Другое оборудование</option>
      </select>
    </div>
    <div class="field" v-if="mode == 'solution'">
      <select class="field__input field__input--select" v-model="formData.solution" placeholder="Программное решение">
        <option value="museum">Музейный киоск</option>
        <option value="ar">Фотосессия с AR-эффектом</option>
        <option value="cashier">Киоск-кассир</option>
      </select>
    </div>
    <div class="field">
      <textarea class="field__input" name="text" v-model="formData.text" :class="{'field__input--filled': formData.text }" />
      <div class="field__label" :class="{'filled': formData.text}">Расскажите о своем проекте</div>
    </div>
    <div class="field">
      <label>
        <input type="checkbox" v-model="formData.confirm" />
      Я согласен с Политикой Конфиденциальности</label>
      <div class="field__error">{{ errors.confirm }}</div>
    </div>
    <div class="text-center">
      <template v-if="mode == 'item-request'">
        <input type="hidden" name="request-type" :value="formData.requestType" />
        <input type="hidden" name="equip-model" :value="formData.equipModel" />
      </template>
      <button type="submit" class="button">Отправить</button>
    </div>
    <div class="loading" v-if="userRequest">
      <div class="preloader">
          <div class="circ1"></div>
          <div class="circ2"></div>
          <div class="circ3"></div>
          <div class="circ4"></div>
        </div>
    </div>
  </form>
</template>
<script>
import Validator from '@/utils/Validator.js';
import AjaxProvider from '@/utils/AjaxProvider.js';
import swal from "sweetalert";
const name = 'Feedback'

function data() {
  return {
    formData: {
      email: '',
      equipment: '',
      solution: '',
      name: '',
      phone: '',
      text: '',
      confirm: false,
      requestType: '',
      equipModel: ''
    },
    validationRules: {
      email: 'email',
      name: 'required',
      confirm: 'confirm',
    },
    errors: {
      email: '',
      name: '',
      confirm:'',
    },
    validationRequest: false,
    watcherInstance: null,
    userRequest:false
  }
}

const props = {
  mode: {
    type: String,
    default: 'request'
  },
  equipModel: {
    type: String,
    default: ''
  },
  requestType: {
    type: String,
    default: ''
  }
}

function mounted() {
  if (this.mode == 'equipment' && this.$route.query.type) {
    this.formData.equipment = this.$route.query.type
  }
  if (this.mode == 'solution' && this.$route.query.type) {
    this.formData.solution = this.$route.query.type
  }
  if (this.mode == 'item-request') {
    try {
      this.formData.requestType = this.requestType
      this.formData.equipModel = this.equipModel
    } catch(err){}
  }
}

const watch = {
  validationRequest(value) {
    let inst = this
    if (value) {
      inst.watcherInstance = inst.$watch('formData', () => {
        inst.validate()
      }, {
        deep: true
      })
    } else {
        if (typeof inst.watcherInstance == 'function') {
          inst.watcherInstance()
          inst.watcherInstance = null
        }
    }
  }
}


function validate(enableSubmit = false) {
  let inst = this
  let validation = new Validator(inst.formData, inst.validationRules).make()
  inst.errors = validation.errors

  if (!validation.isValid) {
    inst.validationRequest = true
    return
  }

  enableSubmit && inst.submit()
}


function submit() {
  let inst = this

  if (inst.userRequest)
    return

  inst.userRequest = true

   new AjaxProvider(`service/feedback`, 'post', inst.formData).request((xhr) => {
    const response = inst.getJSON(xhr.responseText)
    if (xhr.status == 200) {
      swal('Спасибо!', 'Мы свяжемся с вами в рабочее время (по Москве)', 'success')
      inst.validationRequest = false
      Object.assign(inst.formData, {
        email: '',
        name: '',
        equipment: '',
        solution: '',
        phone: '',
        text: '',
        confirm: false
      })

      try {
        typeof ym == 'function' && ym(26515410,'reachGoal','zayavka')
        typeof gtag == 'function' && gtag('event', 'Sent', { category: 'order'})
      } catch(err) {}
    } else {
     const message = response.error || 'Что-то пошло не так, попробуйте позже'
      swal('Ошибка', message, 'error')
    }
    inst.userRequest = false
  })
}

export default {
  name,
  data,
  mounted,
  props,
  watch,
  methods: {
    validate,
    submit
  }
}

</script>
